import { Cart } from '@ts/components/Cart';
import { Modal } from '@ts/components/Modal';

export const init = () => {
    createCart();
    setInteractiveElements();
    setHTMXListeners();
    displayCartCount();
}

const setCartCount = (cartCount) => {
    const cartCountElements = document.querySelectorAll('[data-cart-count]');
    if (!cartCountElements || cartCountElements.length === 0) return;
    cartCountElements.forEach((element) => {
        element.setAttribute('data-cart-count', cartCount.toString());
    });
    displayCartCount();
}

const displayCartCount = () => {
    const cartCountElement = document.querySelectorAll('[data-cart-count]');
    if (!cartCountElement || cartCountElement.length === 0) return;
    cartCountElement.forEach((element) => {
        const cartCount = parseInt(element.getAttribute('data-cart-count') || '0', 10);
        
        const cartIconContainer = element.closest('.nav-link');
        if (!cartIconContainer) return;

        let cartWrapper = cartIconContainer.querySelector('.cart-wrapper');
        if (!cartWrapper) {
            cartWrapper = document.createElement('span');
            cartWrapper.classList.add('cart-wrapper');
            element.before(cartWrapper);
        }
        if (!cartWrapper.contains(element)) {
            cartWrapper.appendChild(element);
        }

        let cartCountBadge = cartIconContainer.querySelector('.cart-count-badge');
        if (cartCount) {
            const cartTotal = (cartCount < 100 ) ? cartCount.toString() : '99+';
            if (!cartCountBadge) {
                cartCountBadge = document.createElement('span');
                cartCountBadge.classList.add('cart-count-badge');
            }
            cartCountBadge.textContent = cartTotal;
            cartWrapper.appendChild(cartCountBadge);
        } else {
            cartCountBadge?.remove();
        }
        element.setAttribute('data-cart-count', cartCount.toString());
    });
}

const createCart = () => {
    Cart.create('#shopping-cart-trigger', {
        panelSelector: '.cart-panel',
        onOpen: handleOnCartOpen,
        onClose: handleOnCartClose
    });
}

const showBadge = () => {
    const cartBadge = document.querySelectorAll('.cart-count-badge');
    cartBadge.forEach((badge) => {
        badge.removeAttribute('hidden');
    });
}

const hideBadge = () => {
    const cartBadge = document.querySelectorAll('.cart-count-badge');
    cartBadge.forEach((badge) => {
        badge.setAttribute('hidden', 'true');
    });
}

const handleOnCartOpen = async () => {
    hideBadge();
}

const handleOnCartClose = async () => {
    // Check Cart Count... 
    const getCartUrl = document.getElementById('cart-panel')?.dataset.cartCountUrl;
    if (!getCartUrl) return;
    const cartCount = await getCartCount(getCartUrl);
    setCartCount(cartCount);
    showBadge();
}

const getCartCount = async (endpoint) => {
    return fetch(endpoint)
        .then(response => response.json())
        .then(data => {
            return data.count;
        })
        .catch(error => {
            console.error('Error fetching cart contents:', error);
            Modal.createAlertModal({
                title: 'Error',
                message: 'There was an error checking your cart contents. Please try again later.',
                closeBtnLabel: 'Close'
            });
            return false;
        });
}

const setInteractiveElements = () => {
    setCloseCartTrigger();
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:confirm', setCartEditable);
    document.body.addEventListener('htmx:afterSettle', setInteractiveElements);
}

export const checkCartEditableStatus = async () => {
    try {
        const cartPanel = document.getElementById('cart-panel');
        const cartEditableUrl = cartPanel?.dataset.cartEditableUrl;
        if (!cartEditableUrl) return;
        const response = await fetch(cartEditableUrl);
        const data = await response.json();
        return Boolean(data.isEditable);
    } catch (error) {
        console.error('Error checking cart editable status:', error);
        return false;
    }
}

const setCartEditable = async (e) => {
    const targetId = e.detail.target.id;
    const trigger = e.detail.requestConfig?.triggeringEvent?.srcElement?.id;
    if (targetId !== 'cart-panel' || trigger === 'shopping-cart-trigger') return;  
     e.preventDefault();

    const isEditable = await checkCartEditableStatus();
    if (isEditable) {  
        e.detail.issueRequest(true);
        return;
    }
    Modal.createAlertModal({
        title: 'Error',
        message: 'Your cart is currently locked. Please complete checkout in your other tab or try again later.',
        closeBtnLabel: 'Close'
    });
    Cart.closeAll();
}

const setCloseCartTrigger = () => {
    const closeBtn = document.querySelectorAll('.cart-panel .close-cart');
    if (!closeBtn) return;
    closeBtn.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            Cart.closeAll();
        });
    });
}